module.exports = __webpack_public_path__ + "img/desktop-front.65b797ed.png";